var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmsFilled16X16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6258_107621)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 5,
    fill: "#74C182"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78037 5.35603C4.55882 5.56176 4.3832 5.9172 4.3832 6.54154V9.4582C4.3832 10.0825 4.55882 10.438 4.78037 10.6437C5.0093 10.8563 5.37585 10.9915 5.91654 10.9915H10.0832C10.6239 10.9915 10.9904 10.8563 11.2194 10.6437C11.4409 10.438 11.6165 10.0825 11.6165 9.4582V6.54154C11.6165 5.9172 11.4409 5.56176 11.2194 5.35603C10.9904 5.14346 10.6239 5.0082 10.0832 5.0082H5.91654C5.37585 5.0082 5.0093 5.14346 4.78037 5.35603ZM4.03187 4.54996C4.53211 4.08545 5.20722 3.9082 5.91654 3.9082H10.0832C10.7925 3.9082 11.4676 4.08545 11.9679 4.54996C12.4755 5.02132 12.7165 5.70754 12.7165 6.54154V9.4582C12.7165 10.2922 12.4755 10.9784 11.9679 11.4498C11.4676 11.9143 10.7925 12.0915 10.0832 12.0915H5.91654C5.20722 12.0915 4.53211 11.9143 4.03187 11.4498C3.52425 10.9784 3.2832 10.2922 3.2832 9.4582V6.54154C3.2832 5.70754 3.52425 5.02132 4.03187 4.54996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5136 6.40697C10.7032 6.64431 10.6645 6.99039 10.4271 7.17996L9.12295 8.22163C8.4933 8.72291 7.5043 8.72345 6.87464 8.22217L6.87329 8.22109L5.57329 7.17942C5.33624 6.98948 5.29806 6.64334 5.488 6.4063C5.67794 6.16925 6.02408 6.13107 6.26113 6.32101L7.56033 7.36203C7.78902 7.54356 8.20826 7.5435 8.43682 7.36185C8.43672 7.36193 8.43693 7.36176 8.43682 7.36185L9.74063 6.32047C9.97797 6.1309 10.324 6.16963 10.5136 6.40697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6258_107621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsFilled16X16);
export default __webpack_public_path__ + "static/media/sms-filled-16x16.5b6fe0dd08eba211a825522c33af74bb.svg";
export { ForwardRef as ReactComponent };